import { render } from "./VehiclesList.vue?vue&type=template&id=1b206b5e"
import script from "./VehiclesList.vue?vue&type=script&lang=js"
export * from "./VehiclesList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__